import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";

@Component({
  selector: "app-portfolio",
  templateUrl: "./portfolio.component.html",
  styleUrls: ["./portfolio.component.scss"],
})
export class PortfolioComponent implements OnInit {
  hideElement = false;

  constructor(public router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === "/private" || event.url === "/private#studyCases") {
          this.hideElement = true;
        } else {
          this.hideElement = false;
        }
      }
    });
  }

  ngOnInit() {
    $(".portfolio-grid a").hover(
      function () {
        $(this).find(".caption").fadeIn(250);
      },
      function () {
        $(this).find(".caption").fadeOut(250);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/portfolio/portfolio.component.ts